/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */
import BLAKE2s from "blake2s-js"

function hash(string) {
  const h = new BLAKE2s(32)
  h.update(new TextEncoder().encode(string))
  return h.hexDigest()
}

export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && localStorage.getItem("gatsbyUser")
    ? JSON.parse(localStorage.getItem("gatsbyUser"))
    : {}

const setUser = user => localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ username, password}) => {
  if (
    hash(username) === 'cf1b7380c324f8e91255ee07bd088515c3410e00131cbdf01d01f52476e503d4'
    && hash(password) === '1b2c9885751f9ab1ba9bb59ea3df7c93e97601108da54e857c66aa7f7ea14a33'
  ) {
    setUser({
      username: `mnemio`,
      name: `Mnemio the Creator`,
      role: 'Creative engineer'
    })
    return true
  }

  return false
}

export const isLoggedIn = () => {
  const user = getUser()

  return !!user.username
}

export const logout = callback => {
  setUser({})
  callback()
}
